export const siteName = "棒棒TV";

export const headerNav = [
  { label: "首页", href: "#hero" },
  { label: "焦点推荐", href: "#carousel" },
  { label: "常见问题", href: "#faq" },
  { label: "联系我们", href: "#contact" },
  { label: "关于棒棒TV", href: "#about" },
  { label: "移动客户端", href: "#app" },
];

export const updates = [
  {
    id: 1,
    date: "2026-07-30",
    title: "《暗夜追踪》第三季全12集已上线，4K画质秒播体验全面升级",
    tag: "新剧上线",
  },
  {
    id: 2,
    date: "2026-07-29",
    title: "暑期档热播剧《长安秘录》更新至第28集，播放引擎优化加载再提速30%",
    tag: "热播更新",
  },
  {
    id: 3,
    date: "2026-07-28",
    title: "棒棒TV移动端全新改版，新增离线预加载功能，地铁追剧零等待",
    tag: "功能升级",
  },
  {
    id: 4,
    date: "2026-07-27",
    title: "《星际迷航：新纪元》独家上线，支持HDR臻彩画质，视觉体验再突破",
    tag: "独家上线",
  },
  {
    id: 5,
    date: "2026-07-26",
    title: "动画频道扩容，一口气上线52部高分国漫日漫，全集免费畅看",
    tag: "内容扩充",
  },
  {
    id: 6,
    date: "2026-07-25",
    title: "纪录片专区新增BBC、Discovery经典系列，高清修复版画质出众",
    tag: "专区上新",
  },
  {
    id: 7,
    date: "2026-07-24",
    title: "智能推荐算法迭代至v3.2版本，千人千面精准匹配你的观影偏好",
    tag: "技术升级",
  },
  {
    id: 8,
    date: "2026-07-23",
    title: "《极限挑战》第十季全网同步更新，综艺频道播放流畅度行业领先",
    tag: "综艺更新",
  },
];

export const topics = [
  { id: 1, name: "暑期档热播", count: "128.6万", hot: true },
  { id: 2, name: "国产悬疑剧", count: "96.3万", hot: true },
  { id: 3, name: "韩剧精选", count: "85.7万", hot: false },
  { id: 4, name: "高分电影", count: "73.2万", hot: true },
  { id: 5, name: "国漫崛起", count: "68.9万", hot: false },
  { id: 6, name: "美剧经典", count: "62.4万", hot: false },
  { id: 7, name: "纪录片推荐", count: "51.8万", hot: false },
  { id: 8, name: "日剧剧场", count: "47.5万", hot: false },
  { id: 9, name: "综艺乐翻天", count: "42.1万", hot: false },
];

export const faqs = [
  {
    id: 1,
    question: "棒棒TV真的免费吗？需要注册会员吗？",
    answer: "完全免费！棒棒TV承诺所有视频内容永久免费播放，无需注册、无需登录、无需会员，打开即看。我们通过广告合作维持运营，绝不会向用户收取任何费用。",
  },
  {
    id: 2,
    question: "为什么棒棒TV能做到不缓冲秒播？",
    answer: "我们自研了分布式CDN加速引擎，在全国部署超过2000个加速节点，结合智能预加载技术，在你点击播放前已经完成首段视频的预缓冲，实现真正的即点即看零等待。",
  },
  {
    id: 3,
    question: "支持哪些设备观看？画质怎么样？",
    answer: "棒棒TV全面支持电脑、平板、手机等所有设备，自适应不同屏幕尺寸。画质方面，我们从标清到4K HDR全覆盖，根据你的网络状况智能选择最佳清晰度，确保流畅不卡顿。",
  },
  {
    id: 4,
    question: "电视剧和电影的更新速度快吗？",
    answer: "我们拥有专业的内容运营团队，热门剧集当日同步更新，电影资源第一时间上线。综艺节目、动漫番剧也会在播出后最快2小时内完成上架，让你不错过任何精彩。",
  },
  {
    id: 5,
    question: "播放过程中会弹广告吗？",
    answer: "棒棒TV采用清爽的观看体验设计，视频播放过程中不会弹出任何遮挡广告。我们仅在页面周边展示少量品牌广告，保证观影过程的沉浸感不打折扣。",
  },
];

export const indexItems = [
  {
    id: 1,
    title: "热门电视剧全集",
    desc: "收录当前最火爆的国产剧、韩剧、美剧、日剧，全集打包不追更",
    icon: "ri-tv-line",
    count: "2,860部",
  },
  {
    id: 2,
    title: "高分电影大全",
    desc: "涵盖动作、喜剧、悬疑、爱情、科幻等全类型，IMDb & 豆瓣高分精选",
    icon: "ri-film-line",
    count: "5,420部",
  },
  {
    id: 3,
    title: "综艺娱乐专区",
    desc: "热门综艺实时更新，搞笑、音乐、竞技、旅行…… 你想看的全都有",
    icon: "ri-emotion-laugh-line",
    count: "1,350档",
  },
  {
    id: 4,
    title: "动漫番剧仓库",
    desc: "国漫日漫美漫一网打尽，经典老番与当季新番同步收录",
    icon: "ri-ghost-line",
    count: "3,780部",
  },
  {
    id: 5,
    title: "纪录片知识库",
    desc: "BBC、Discovery、NHK等顶级纪录片资源，高清修复画质出众",
    icon: "ri-earth-line",
    count: "1,920部",
  },
  {
    id: 6,
    title: "少儿亲子乐园",
    desc: "精选优质儿童动画、早教内容，家长放心孩子开心的安全观影空间",
    icon: "ri-heart-line",
    count: "2,340部",
  },
  {
    id: 7,
    title: "4K臻彩专区",
    desc: "HDR + 4K超高清专享片库，用最好的画质看最爱的影片",
    icon: "ri-4k-line",
    count: "890部",
  },
];

export const contactInfo = {
  title: "联系我们",
  desc: "如果您有内容建议、合作意向或遇到播放问题，欢迎随时与我们取得联系。棒棒TV团队将在24小时内回复您的反馈。",
  email: "feedback@bangbangtv.tv",
  wechat: "BangBangTV_Official",
  qq: "800123456",
};

export const carouselItems = [
  {
    id: 1,
    title: "《暗夜追踪》第三季",
    subtitle: "豆瓣8.7分 · 悬疑烧脑神作回归",
    desc: "暗夜之中真相渐显，每一帧都让人屏息凝神。全新一季剧情更加扑朔迷离，4K HDR画质带来影院级观感。",
    tag: "爆款推荐",
    image: "https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20atmosphere%20with%20silhouette%20of%20detective%20in%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20lighting%20with%20deep%20shadows%20and%20warm%20accents%2C%20film%20noir%20style%2C%20movie%20poster%20aesthetic%2C%20dramatic%20composition&width=640&height=400&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "《长安秘录》热播中",
    subtitle: "古装悬疑 · 全网播放量破50亿",
    desc: "盛唐长安，一桩离奇案件牵出惊天秘密。服化道精良，剧情环环相扣，每集结尾都是神级反转。",
    tag: "热播追更",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20palace%20scene%20with%20dramatic%20lighting%2C%20traditional%20architecture%20and%20lanterns%20in%20warm%20golden%20glow%2C%20mysterious%20atmosphere%20with%20flowing%20silk%20robes%2C%20cinematic%20composition%20reminiscent%20of%20historical%20drama%20poster%2C%20rich%20warm%20red%20and%20gold%20tones&width=640&height=400&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "《星际迷航：新纪元》",
    subtitle: "科幻巨制 · 独家HDR臻彩上线",
    desc: "浩瀚宇宙中人类文明的终极探索，视觉特效达到电影级水准。IMAX Enhanced认证，每一帧都是壁纸。",
    tag: "独家首发",
    image: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20spaceship%20traveling%20through%20colorful%20nebula%20in%20deep%20space%2C%20stars%20and%20galaxies%20in%20background%2C%20cinematic%20composition%20with%20dramatic%20lighting%2C%20futuristic%20design%2C%20film%20poster%20style%20with%20vibrant%20purple%20and%20blue%20cosmic%20colors%2C%20high%20contrast&width=640&height=400&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "《极限挑战》第十季",
    subtitle: "国民综艺 · 笑点密集停不下来",
    desc: "原班人马回归，新一季玩法升级更刺激。轻松解压首选，每期都有意想不到的爆笑名场面。",
    tag: "综艺热播",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20aesthetic%20with%20colorful%20confetti%20and%20dynamic%20lighting%2C%20group%20of%20people%20laughing%20and%20having%20fun%20on%20a%20brightly%20lit%20stage%2C%20energetic%20atmosphere%20with%20warm%20spotlights%2C%20entertainment%20show%20poster%20style%2C%20joyful%20and%20lively%20composition&width=640&height=400&seq=carousel-04&orientation=landscape",
  },
  {
    id: 5,
    title: "《深海冒险》动画电影",
    subtitle: "国漫巅峰 · 票房口碑双丰收",
    desc: "历时五年匠心打造，每一帧都是精雕细琢的艺术品。奇幻海底世界的视觉盛宴，全年龄段都值得一看。",
    tag: "国漫之光",
    image: "https://readdy.ai/api/search-image?query=Magical%20underwater%20animated%20scene%20with%20colorful%20coral%20reefs%20and%20fantastical%20sea%20creatures%2C%20sunlight%20streaming%20through%20crystal%20clear%20water%2C%20dreamy%20atmosphere%20with%20bioluminescent%20glow%2C%20animated%20film%20poster%20style%2C%20rich%20teal%20and%20warm%20coral%20colors%2C%20whimsical%20composition&width=640&height=400&seq=carousel-05&orientation=landscape",
  },
  {
    id: 6,
    title: "《BBC地球脉动》全集",
    subtitle: "9.9分神作 · 4K修复版震撼上线",
    desc: "跨越七大洲四大洋的自然奇迹，每一帧都是生命的礼赞。汉斯·季默配乐加持，视听双重享受。",
    tag: "纪录经典",
    image: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20photography%20of%20vast%20mountains%20and%20glaciers%20with%20golden%20sunset%20light%2C%20dramatic%20natural%20scenery%20with%20rich%20earthy%20tones%2C%20nature%20documentary%20film%20poster%20aesthetic%2C%20epic%20scale%20and%20grandeur%2C%20warm%20golden%20hour%20lighting%20on%20snow%20capped%20peaks&width=640&height=400&seq=carousel-06&orientation=landscape",
  },
];

export const features = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "秒播不缓冲",
    desc: "自研CDN加速引擎，2000+节点全国覆盖，即点即看零等待，告别加载转圈圈",
  },
  {
    id: 2,
    icon: "ri-4k-line",
    title: "高清臻彩画质",
    desc: "从标清到4K HDR全覆盖，智能码率自适应，网络状况再差也能流畅看高清",
  },
  {
    id: 3,
    icon: "ri-smartphone-line",
    title: "全设备兼容",
    desc: "电脑、平板、手机无缝切换，支持Chromecast和AirPlay投屏，大屏小屏随心看",
  },
  {
    id: 4,
    icon: "ri-database-2-line",
    title: "海量片库",
    desc: "超过2万部影视内容，涵盖电视剧、电影、综艺、动漫、纪录片，每日持续更新",
  },
  {
    id: 5,
    icon: "ri-shield-check-line",
    title: "纯净观影",
    desc: "播放过程零弹窗广告，清爽界面设计，给你沉浸式观影体验不被打扰",
  },
];

export const cards = [
  {
    id: 1,
    title: "悬疑剧专场：烧脑不停",
    desc: "精选20部高分悬疑剧，反转不断、细节拉满，适合喜欢推理破案的你一口气刷完。",
    tag: "悬疑迷必看",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20vintage%20desk%20lamp%20casting%20warm%20light%20on%20case%20files%20and%20magnifying%20glass%2C%20dark%20wood%20furniture%2C%20shadows%20and%20warm%20accents%2C%20film%20noir%20inspired%20still%20life%2C%20cinematic%20composition%20with%20rich%20amber%20and%20deep%20brown%20tones&width=400&height=280&seq=card-01&orientation=landscape",
  },
  {
    id: 2,
    title: "暑期亲子观影指南",
    desc: "整理了30部适合全家一起看的优质动画和儿童电影，寓教于乐安全放心。",
    tag: "亲子时光",
    image: "https://readdy.ai/api/search-image?query=Cozy%20family%20living%20room%20with%20warm%20string%20lights%2C%20colorful%20cushions%20on%20sofa%2C%20soft%20blanket%2C%20bowl%20of%20popcorn%2C%20gentle%20evening%20atmosphere%2C%20family%20movie%20night%20aesthetic%2C%20warm%20golden%20and%20cream%20tones%2C%20inviting%20composition&width=400&height=280&seq=card-02&orientation=landscape",
  },
  {
    id: 3,
    title: "韩剧经典：二十年精选",
    desc: "从《蓝色生死恋》到《黑暗荣耀》，横跨二十年的韩剧发展史，经典永不过时。",
    tag: "韩流经典",
    image: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20aesthetic%20scene%20with%20cherry%20blossom%20trees%20in%20soft%20spring%20light%2C%20couple%20silhouette%20on%20park%20bench%2C%20dreamy%20bokeh%20background%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20cinematic%20romantic%20composition&width=400&height=280&seq=card-03&orientation=landscape",
  },
  {
    id: 4,
    title: "纪录片里的中国",
    desc: "从《舌尖上的中国》到《航拍中国》，用镜头记录这片土地的壮美与温度。",
    tag: "人文经典",
    image: "https://readdy.ai/api/search-image?query=Aerial%20photography%20of%20traditional%20Chinese%20terraced%20rice%20fields%20in%20golden%20morning%20mist%2C%20layered%20green%20hills%2C%20warm%20sunrise%20light%20breaking%20through%20clouds%2C%20breathtaking%20natural%20landscape%2C%20documentary%20film%20aesthetic%2C%20rich%20emerald%20and%20golden%20tones&width=400&height=280&seq=card-04&orientation=landscape",
  },
  {
    id: 5,
    title: "高分喜剧：笑到停不下来",
    desc: "心情不好的时候，打开这份片单就够了。收录IMDb 8分以上的爆笑神作。",
    tag: "快乐源泉",
    image: "https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20living%20room%20scene%20with%20colorful%20decorations%2C%20vintage%20movie%20posters%20on%20wall%2C%20comfortable%20sofa%20with%20yellow%20cushions%2C%20warm%20sunlight%20streaming%20through%20window%2C%20playful%20and%20joyful%20atmosphere%2C%20comedic%20film%20aesthetic%2C%20vibrant%20warm%20tones&width=400&height=280&seq=card-05&orientation=landscape",
  },
];

export const aboutContent = {
  title: "关于棒棒TV",
  paragraphs: [
    "棒棒TV成立于2020年，是国内领先的免费高清视频在线播放平台。我们致力于为每一位用户提供不缓冲、秒播放、零等待的极致观影体验，让优质影视内容触手可及。",
    "平台汇聚了超过20,000部影视内容，涵盖热门电视剧、高分电影、爆笑综艺、精品动漫和经典纪录片等多个品类。无论是国产剧爱好者、韩剧迷、美剧控还是动漫宅，都能在棒棒TV找到心仪的内容。",
    "技术是棒棒TV的核心驱动力。我们自研的智能CDN加速引擎在全国部署超过2000个节点，配合AI驱动的码率自适应算法，确保你在任何网络环境下都能流畅享受高清画质。同时，我们坚持\"播放过程零弹窗广告\"的纯净观影理念，让每一次观看都不被打扰。",
    "未来，棒棒TV将持续加大内容投入和技术研发，不断丰富片库、提升播放体验，努力成为每个中国人手机里必备的免费视频App。",
  ],
  stats: [
    { value: "20,000+", label: "影视内容" },
    { value: "5,000万+", label: "月活用户" },
    { value: "2,000+", label: "加速节点" },
    { value: "99.9%", label: "服务可用率" },
  ],
};

export const comments = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20young%20man%20with%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20modern%20casual%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "追剧达人小王",
    time: "2天前",
    content: "用了半年棒棒TV了，真的不卡！我家里网速一般，其他平台经常加载半天，棒棒TV真的是即点即看，体验感拉满。画质也很清晰，推荐给了好多朋友。",
    rating: 5,
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20young%20woman%20with%20gentle%20smile%2C%20clean%20light%20background%2C%20soft%20studio%20lighting%2C%20elegant%20casual%20style%2C%20warm%20friendly%20expression&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "电影迷小陈",
    time: "5天前",
    content: "片库太全了！之前到处找不到的老电影，棒棒TV上居然有高清修复版。纪录片资源也很丰富，BBC那几部自然纪录片我反复看了三遍。",
    rating: 5,
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20student%20with%20glasses%20and%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20light%2C%20youthful%20casual%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "学生党阿杰",
    time: "1周前",
    content: "学生党狂喜！免费不用会员，而且没有那种烦人的播放中广告。宿舍WiFi四个人同时看都不卡，室友全被我安利入坑了。",
    rating: 5,
  },
  {
    id: 4,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20in%2030s%20with%20confident%20warm%20smile%2C%20clean%20light%20gray%20background%2C%20soft%20studio%20lighting%2C%20modern%20professional%20style&width=80&height=80&seq=avatar-04&orientation=squarish",
    name: "职场人Lisa",
    time: "2周前",
    content: "下班后追剧是我最大的放松方式。棒棒TV的移动端做得很好，地铁上也能秒播不缓冲，离线预加载功能真的太实用了，必须给个好评。",
    rating: 4,
  },
  {
    id: 5,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%2040s%20with%20kind%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20light%2C%20mature%20casual%20style&width=80&height=80&seq=avatar-05&orientation=squarish",
    name: "宝爸老张",
    time: "3周前",
    content: "少儿专区做得很好，孩子看的动画片都是精选过的，内容安全放心。画质清晰还不伤眼睛，现在周末陪娃看动画成了固定节目。",
    rating: 5,
  },
];

export const appInfo = {
  title: "棒棒TV · 移动客户端",
  subtitle: "随时随地，秒播不等待",
  desc: "棒棒TV移动App全面支持iOS和Android平台，专为移动场景深度优化。离线预加载、智能省流模式、夜间观影护眼…… 你的口袋影院，下载即享。",
  features: [
    "离线预加载，地铁追剧零等待",
    "智能省流模式，流量看片不心疼",
    "夜间护眼模式，熬夜追剧也舒适",
    "画中画悬浮窗，边聊边看不耽误",
    "个性化推荐，越用越懂你",
  ],
  image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20video%20streaming%20app%20interface%20on%20screen%2C%20clean%20minimal%20design%20with%20warm%20accent%20colors%2C%20floating%20phone%20on%20clean%20light%20background%2C%20soft%20shadow%2C%20product%20photography%20style%2C%20elegant%20composition&width=360&height=640&seq=app-mockup&orientation=portrait",
};

export const rankingItems = [
  { id: 1, rank: 1, title: "暗夜追踪 第三季", type: "悬疑剧", hot: "🔥 980万", trend: "up" },
  { id: 2, rank: 2, title: "长安秘录", type: "古装剧", hot: "🔥 920万", trend: "up" },
  { id: 3, rank: 3, title: "极限挑战 第十季", type: "综艺", hot: "🔥 870万", trend: "up" },
  { id: 4, rank: 4, title: "星际迷航：新纪元", type: "科幻片", hot: "🔥 820万", trend: "new" },
  { id: 5, rank: 5, title: "深海冒险", type: "动画", hot: "🔥 760万", trend: "up" },
  { id: 6, rank: 6, title: "BBC地球脉动", type: "纪录片", hot: "🔥 710万", trend: "up" },
  { id: 7, rank: 7, title: "极限特工：暗影行动", type: "动作片", hot: "🔥 680万", trend: "new" },
];

export const mediaItems = [
  {
    id: 1,
    title: "《暗夜追踪》高燃混剪",
    desc: "三季名场面一次看过瘾",
    duration: "08:32",
    image: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20with%20dramatic%20lighting%2C%20silhouette%20of%20figure%20standing%20in%20rainy%20alleyway%20with%20neon%20reflections%2C%20film%20noir%20aesthetic%2C%20suspenseful%20atmosphere%2C%20movie%20scene%20still%20with%20warm%20amber%20and%20cool%20blue%20contrast&width=560&height=315&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "《长安秘录》幕后花絮",
    desc: "服化道全揭秘，每一帧都是匠心",
    duration: "12:15",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20historical%20Chinese%20drama%20costume%20design%20workshop%2C%20intricate%20traditional%20embroidery%20details%2C%20warm%20lighting%20on%20silk%20fabrics%2C%20artisan%20craftsmanship%2C%20rich%20golden%20and%20crimson%20tones%2C%20cinematic%20documentary%20style&width=560&height=315&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "《星际迷航》视效解析",
    desc: "好莱坞团队打造，每一帧都是壁纸",
    duration: "06:48",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20cockpit%20interior%20with%20holographic%20displays%20and%20warm%20ambient%20lighting%2C%20sleek%20sci-fi%20design%2C%20stars%20visible%20through%20large%20window%2C%20cinematic%20composition%2C%20rich%20metallic%20and%20warm%20amber%20tones&width=560&height=315&seq=media-03&orientation=landscape",
  },
  {
    id: 4,
    title: "《极限挑战》爆笑集锦",
    desc: "本季最好笑的名场面都在这里了",
    duration: "15:20",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20moment%20with%20colorful%20stage%20lighting%20and%20confetti%2C%20group%20of%20people%20celebrating%20with%20genuine%20laughter%2C%20dynamic%20and%20joyful%20atmosphere%2C%20warm%20golden%20spotlights%2C%20entertainment%20show%20aesthetic&width=560&height=315&seq=media-04&orientation=landscape",
  },
];